import initialState from '../../store/initialState';
import MainTipos from './MainTipos';

const ModalErrorReducer = (state = initialState.modales, action) => {
    if (action.type === MainTipos.data.MOSTRAR_MODAL_ERROR_GENERICO) {
        return {
            ...state,
            showErrorGenerico: action.payload.showModal,
        };
    }
    return state;
}

export default ModalErrorReducer;